import React from 'react';
import { StyleSheet, View } from 'react-native';

import Text from '../global/Text';
import { AuthContainerProps } from './AuthContainer';
import { useTranslation } from 'react-i18next';
import { AUTH_MODE } from '../../constants/Constants';
import fontMaker from '../../utils/font';

type AuthFormHeaderProps = Pick<AuthContainerProps, 'authMode' | 'language'>;

const SUBTITLE_MAP: Partial<Record<AUTH_MODE, string>> = {
  [AUTH_MODE.LOGIN]: 'auth:formHeader.loginSubtitle',
  [AUTH_MODE.RESET_PASSWORD]: 'auth:formHeader.resetSubtitle',
  [AUTH_MODE.SIGN_UP]: 'auth:formHeader.activateSubtitle'
};

const AuthFormHeader = (props: AuthFormHeaderProps) => {
  const { t } = useTranslation(['auth', 'common']);

  const subtitleKey = SUBTITLE_MAP[props.authMode];

  return (
    <View style={styles.header}>
      {props.authMode === AUTH_MODE.LOGIN ? (
        <Text allowFontScaling={false} style={styles.headerText}>
          {t('common:login')}
        </Text>
      ) : props.authMode === AUTH_MODE.RESET_PASSWORD ? (
        <Text allowFontScaling={false} style={styles.headerText}>
          {t('common:forgotPassword')}
        </Text>
      ) : props.authMode === AUTH_MODE.SIGN_UP ? (
        <Text allowFontScaling={true} style={styles.headerTextMultiline}>
          {t('auth:formHeader.activateAccount')}
        </Text>
      ) : null}
      {subtitleKey ? <Text style={styles.subtitle}>{t(subtitleKey)}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    width: 440,
    maxWidth: '90%',
    alignSelf: 'center',
    paddingBottom: 10,
    paddingTop: 4,
    alignItems: 'center'
  },
  headerText: {
    ...fontMaker({ weight: 'Bold' }),
    color: '#101828',
    textAlign: 'center',
    fontSize: 28,
    lineHeight: 38
  },
  headerTextMultiline: {
    ...fontMaker({ weight: 'Bold' }),
    color: '#101828',
    textAlign: 'center',
    fontSize: 24,
    lineHeight: 34
  },
  subtitle: {
    ...fontMaker({ weight: 'Regular' }),
    color: '#667085',
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 20,
    marginTop: 6,
    marginBottom: 12,
    maxWidth: 380
  }
});

export default AuthFormHeader;
